<template>
    <div>
        <!-- Empty state. -->
        <div v-if="empty">
            <div class="info-box--grey pa16 matb15">
                <h3>{{ say.empty_proposals }}</h3>
                <base-button
                    class="btn-fill"
                    btn4
                    @click="$router.push({name: 'user-edit-profile', alias: true})"
                >
                    {{ say.fill_city }}
                </base-button>
            </div>
        </div>

        <!-- Competitions list. -->
        <base-item-competition
            v-for="id in competitionsIds"
            :id="id"
            :key="id"
        />

        <!-- Search more button. -->
        <base-button
            v-if="!empty"
            class="btn-findmore"
            btn4
            @click="$router.push({name:'main-list', alias: true})"
        >
            {{ say.find_other_competition }}
        </base-button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { READ_USER_COMPETITIONS } from '@/store/actions.type';

export default {
    data() {
        return {
            competitionsIds: [-1],
        };
    },
    computed: {
        ...mapGetters(['say']),
        empty() {
            return this.competitionsIds.length === 0;
        },
    },
    async created() {
        const { competitions } = await this.READ_USER_COMPETITIONS({
            type: 'proposed',
        });

        this.competitionsIds = competitions;
    },
    methods: {
        ...mapActions([READ_USER_COMPETITIONS]),
    },
};
</script>

<style scoped>
.btn-fill {
    background-color: var(--color-white);
    margin-bottom: 16px;
    margin-top: 60px;
    max-width: 263px;
}
.btn-findmore {
    margin: 30px 0;
}

@media (min-width: 992px) {
    .btn-findmore {
        width: 263px;
    }
}
</style>
